import { Locale } from 'corgi-types';
import { Locale as CorgiLocale } from 'corgi/common/enums/Locale';
import type { GQLLocale } from 'graphql-ts-types';

export const toCorgiLocale = (locale: Locale) =>
  (locale === Locale.DE_DE ? CorgiLocale.De_De_H24 : locale) as CorgiLocale;

export const toGQLLocale = (locale: Locale): GQLLocale => locale as unknown as GQLLocale;
